/* ==========================================================================
   MIO Concept — comportamento do tema (V3)
   ========================================================================== */
(function () {

  /* --- Rotação das fotografias do mosaico --------------------------------- */
  function initMosaico() {
    var caixa = document.querySelector('[data-mio-cats]');
    if (!caixa) return;
    var modo = caixa.getAttribute('data-rotate') || 'off';
    if (modo === 'off') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) modo = 'load';

    var segundos = parseInt(caixa.getAttribute('data-seconds'), 10) || 20;

    caixa.querySelectorAll('[data-mio-cat]').forEach(function (cat, i) {
      var urls = (cat.getAttribute('data-imgs') || '').split('|').filter(Boolean);
      if (urls.length < 2) return;

      var a = cat.querySelector('.mio-cat__img.is-on');
      var b = cat.querySelector('.mio-cat__img.is-off');
      if (!a || !b) return;

      var pos = Math.floor(Math.random() * urls.length);

      function troca(url) {
        var prox = new Image();
        prox.onload = function () {
          b.src = url;
          b.removeAttribute('srcset');
          b.classList.remove('is-off'); b.classList.add('is-on');
          a.classList.remove('is-on'); a.classList.add('is-off');
          var t = a; a = b; b = t;
        };
        prox.src = url;
      }

      if (modo === 'load') { troca(urls[pos]); return; }

      // Desfasar o arranque, para os azulejos não trocarem todos ao mesmo tempo
      setTimeout(function () {
        troca(urls[pos]);
        setInterval(function () {
          pos = (pos + 1) % urls.length;
          troca(urls[pos]);
        }, segundos * 1000);
      }, i * Math.round(segundos * 1000 / 4));
    });
  }

  /* --- Carrossel da homepage ---------------------------------------------- */
  function initSplitCarrossel() {
    var caixa = document.querySelector('[data-mio-split].is-carousel');
    if (!caixa) return;

    var slides = caixa.querySelectorAll('[data-mio-split-slide]');
    var pontos = caixa.querySelectorAll('[data-mio-split-dot]');
    if (slides.length < 2) return;

    var atual = 0;
    var segundos = parseInt(caixa.getAttribute('data-autoplay'), 10) || 0;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) segundos = 0;
    var timer = null;

    function mostrar(i) {
      atual = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === atual;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      pontos.forEach(function (p, n) {
        p.classList.toggle('is-active', n === atual);
        p.setAttribute('aria-selected', n === atual ? 'true' : 'false');
      });
    }

    function recomecar() {
      clearInterval(timer);
      if (segundos) timer = setInterval(function () { mostrar(atual + 1); }, segundos * 1000);
    }

    var prev = caixa.querySelector('[data-mio-split-prev]');
    var next = caixa.querySelector('[data-mio-split-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); mostrar(atual - 1); recomecar(); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); mostrar(atual + 1); recomecar(); });
    pontos.forEach(function (p, n) {
      p.addEventListener('click', function (e) { e.preventDefault(); mostrar(n); recomecar(); });
    });

    caixa.addEventListener('mouseenter', function () { clearInterval(timer); });
    caixa.addEventListener('mouseleave', recomecar);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearInterval(timer); } else { recomecar(); }
    });

    // Arrastar com o dedo
    var x0 = null;
    caixa.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    caixa.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { mostrar(dx < 0 ? atual + 1 : atual - 1); recomecar(); }
      x0 = null;
    }, { passive: true });

    recomecar();
  }

  /* --- Densidade da grelha ------------------------------------------------ */
  function initDensidade() {
    var grid = document.querySelector('[data-mio-grid]');
    var botoes = document.querySelectorAll('[data-mio-density]');
    if (!grid || !botoes.length) return;

    function aplicar(n, guardar) {
      grid.setAttribute('data-cols', n);
      botoes.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-mio-density') === String(n));
      });
      if (guardar) { try { localStorage.setItem('mio:cols', n); } catch (e) {} }
    }

    var guardado = null;
    try { guardado = localStorage.getItem('mio:cols'); } catch (e) {}
    aplicar(guardado || grid.getAttribute('data-cols') || 3, false);

    botoes.forEach(function (b) {
      b.addEventListener('click', function () { aplicar(b.getAttribute('data-mio-density'), true); });
    });
  }
  'use strict';

  var t = function (k, f) { return (window.MIO && window.MIO.strings && window.MIO.strings[k]) || f; };

  function money(cents) {
    var f = (window.MIO && window.MIO.moneyFormat) || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    return f
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function thumb(url, w, h) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x' + h + '_crop_center$1$2');
  }

  /* --- Altura do cabeçalho ------------------------------------------------ */
  function initHeaderHeight() {
    var head = document.querySelector('.ed-masthead');
    if (!head) return;
    var sub = document.querySelector('.ed-subnav');
    var set = function () {
      var aviso = document.querySelector('.mio-aviso');
      var h = head.offsetHeight + (sub && sub.offsetHeight ? sub.offsetHeight : 0) + (aviso ? aviso.offsetHeight : 0);
      document.documentElement.style.setProperty('--hdr', h + 'px');
    };
    set();
    window.addEventListener('resize', set);
  }

  /* --- Mega-menu da loja -------------------------------------------------- */
  function initShopMenu() {
    var trigger = document.querySelector('[data-mio-shopmenu-trigger]');
    var menu = document.querySelector('[data-mio-shopmenu]');
    if (!trigger || !menu) return;

    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      menu.hidden = false;
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function lazyClose() {
      closeTimer = setTimeout(close, 180);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      menu.hidden ? open() : close();
    });
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', lazyClose);
    menu.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    menu.addEventListener('mouseleave', lazyClose);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { close(); trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (menu.hidden) return;
      if (!menu.contains(e.target) && !trigger.contains(e.target)) close();
    });
  }

  /* --- Gaveta de menu ----------------------------------------------------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-mio-drawer]');
    if (!drawer) return;

    var veil = document.querySelector('.ed-drawer-veil');
    var botoes = document.querySelectorAll('[data-mio-drawer-open]');

    function open() {
      drawer.classList.add('open');
      if (veil) { veil.hidden = false; requestAnimationFrame(function () { veil.classList.add('open'); }); }
      botoes.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('open');
      if (veil) {
        veil.classList.remove('open');
        setTimeout(function () { veil.hidden = true; }, 400);
      }
      botoes.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
    }

    // Famílias com categorias: abrir e fechar a lista
    drawer.querySelectorAll('[data-mio-dnav-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = b.nextElementSibling;
        if (!sub) return;
        var aberto = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', aberto ? 'false' : 'true');
        sub.hidden = aberto;
      });
    });

    document.querySelectorAll('[data-mio-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-mio-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  }

  /* --- Revelação ao scroll ------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll('.ed-reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Voltar ao topo ----------------------------------------------------- */
  function initToTop() {
    var btn = document.querySelector('[data-mio-totop]');
    if (!btn) return;
    var onScroll = function () { btn.classList.toggle('show', window.scrollY > 700); };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    onScroll();
  }

  /* --- Galeria de produto ------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-mio-gallery]');
    if (!gallery) return;

    var main = gallery.querySelector('[data-mio-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-mio-thumb]');
    var sources = Array.prototype.map.call(thumbs, function (b) { return b.dataset.full; });
    if (!sources.length && main) sources.push(main.currentSrc || main.src);
    var current = 0;

    function show(i) {
      current = (i + sources.length) % sources.length;
      if (main) { main.removeAttribute('srcset'); main.src = sources[current]; }
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === current); });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });

    /* Escolher uma cor troca a fotografia grande pela dessa variante. */
    gallery.mostrarSrc = function (src) {
      if (!src) return;
      var i = sources.indexOf(src);
      if (i >= 0) { show(i); return; }
      if (main) { main.removeAttribute('srcset'); main.src = src; }
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
    };

    var lb = null;
    function openLb() {
      if (lb || !sources.length) return;
      lb = document.createElement('div');
      lb.className = 'ed-lb';
      lb.innerHTML =
        '<figure class="ed-lb-fig"><img alt=""></figure>' +
        '<button class="ed-lb-close" aria-label="' + t('close', 'Fechar') + '">✕</button>' +
        (sources.length > 1
          ? '<button class="ed-lb-nav prev" aria-label="' + t('prev', 'Anterior') + '">‹</button>' +
            '<button class="ed-lb-nav next" aria-label="' + t('next', 'Seguinte') + '">›</button>' +
            '<span class="ed-lb-count"></span>'
          : '');
      document.body.appendChild(lb);
      document.body.style.overflow = 'hidden';

      var img = lb.querySelector('img');
      var count = lb.querySelector('.ed-lb-count');
      function paint() {
        img.src = sources[current];
        if (count) count.textContent = (current + 1) + ' / ' + sources.length;
      }
      paint();

      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      lb.querySelector('.ed-lb-close').addEventListener('click', closeLb);
      var p = lb.querySelector('.prev');
      var n = lb.querySelector('.next');
      if (p) p.addEventListener('click', function () { show(current - 1); paint(); });
      if (n) n.addEventListener('click', function () { show(current + 1); paint(); });

      function keys(e) {
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowRight') { show(current + 1); paint(); }
        if (e.key === 'ArrowLeft') { show(current - 1); paint(); }
      }
      document.addEventListener('keydown', keys);
      lb._keys = keys;
    }
    function closeLb() {
      if (!lb) return;
      document.removeEventListener('keydown', lb._keys);
      lb.remove();
      lb = null;
      document.body.style.overflow = '';
    }

    var zoom = gallery.querySelector('[data-mio-gallery-main]');
    if (zoom) zoom.addEventListener('click', openLb);
  }

  /* --- Variantes ----------------------------------------------------------- */
  function initVariants() {
    var form = document.querySelector('[data-mio-product-form]');
    var data = document.querySelector('[data-mio-variants]');
    if (!form || !data) return;

    var variants = JSON.parse(data.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-mio-price]');
    var submit = form.querySelector('[data-mio-submit]');
    var oos = document.querySelector('[data-mio-oos]');

    function update() {
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('input[type="radio"]:checked'),
        function (r) { return r.value; }
      );
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;

      idInput.value = match.id;

      if (priceEl) {
        priceEl.innerHTML = (match.compare_at_price && match.compare_at_price > match.price)
          ? '<s>' + money(match.compare_at_price) + '</s>' + money(match.price)
          : money(match.price);
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? t('addToCart', 'Adicionar ao carrinho') : t('soldOut', 'Esgotado');
      }
      if (oos) oos.hidden = match.available;

      var galeria = document.querySelector('[data-mio-gallery]');
      if (galeria && galeria.mostrarSrc) galeria.mostrarSrc(match.image);

      form.querySelectorAll('[data-mio-optlabel]').forEach(function (el) {
        var i = parseInt(el.dataset.mioOptlabel, 10);
        el.textContent = chosen[i] || '';
      });

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    form.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', update);
    });
  }

  /* --- Carrinho ------------------------------------------------------------ */
  var Cart = {
    overlay: null,
    panel: null,

    init: function () {
      this.overlay = document.querySelector('[data-mio-cart-overlay]');
      this.panel = document.querySelector('[data-mio-cart-panel]');
      if (!this.panel) return;
      var self = this;

      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.querySelectorAll('[data-mio-cart-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      document.querySelectorAll('[data-mio-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      document.addEventListener('click', function (e) {
        var add = e.target.closest('[data-mio-quick-add]');
        if (add) { e.preventDefault(); self.add(add.dataset.mioQuickAdd, 1, add); return; }

        var qty = e.target.closest('[data-mio-qty]');
        if (qty) { self.change(qty.dataset.key, parseInt(qty.dataset.mioQty, 10)); return; }

        var rm = e.target.closest('[data-mio-remove]');
        if (rm) { self.change(rm.dataset.key, 0); }
      });

      var form = document.querySelector('[data-mio-product-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var id = form.querySelector('[name="id"]').value;
          var q = form.querySelector('[name="quantity"]');
          self.add(id, q ? parseInt(q.value, 10) : 1, form.querySelector('[data-mio-submit]'));
        });
      }

      this.refresh();
    },

    open: function () {
      this.panel.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      this.panel.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    },

    add: function (id, qty, btn) {
      var self = this;
      if (btn) btn.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) { self.error(res.description || res.message); return; }
          if (btn) btn.classList.add('in-cart');
          self.refresh(true);
        })
        .catch(function () { self.error(t('cartError', 'Não foi possível adicionar a peça.')); })
        .finally(function () { if (btn) btn.disabled = false; });
    },

    change: function (key, qty) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },

    error: function (msg) {
      var box = this.panel && this.panel.querySelector('[data-mio-cart-error]');
      if (!box) return;
      box.textContent = msg;
      box.hidden = false;
      setTimeout(function () { box.hidden = true; }, 5000);
    },

    refresh: function (andOpen) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.render(cart);
          if (andOpen) self.open();
        });
    },

    render: function (cart) {
      document.querySelectorAll('[data-mio-cart-count]').forEach(function (c) {
        c.textContent = cart.item_count;
        c.hidden = cart.item_count === 0;
      });

      // Elementos que so fazem sentido com o carrinho preenchido
      document.querySelectorAll('[data-mio-when-cart]').forEach(function (e) {
        e.hidden = cart.item_count === 0;
      });

      if (!this.panel) return;

      var tally = this.panel.querySelector('[data-mio-cart-tally]');
      var body = this.panel.querySelector('[data-mio-cart-body]');
      var foot = this.panel.querySelector('[data-mio-cart-foot]');
      var total = this.panel.querySelector('[data-mio-cart-total]');

      if (tally) {
        tally.textContent = cart.item_count
          ? cart.item_count + ' ' + (cart.item_count === 1 ? t('piece', 'peça') : t('pieces', 'peças'))
          : '';
      }

      if (!cart.items.length) {
        body.innerHTML =
          '<div class="ed-cart-empty"><p>' + t('cartEmpty', 'Ainda não escolheste nenhuma peça.') + '</p>' +
          '<a class="ed-cart-empty-link" href="' + (window.MIO.shopUrl || '/collections/all') + '">' +
          t('viewShop', 'Ver a loja') + '</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      body.innerHTML = '<ul class="ed-cart-list">' + cart.items.map(function (it) {
        var img = it.image
          ? '<div class="ed-cart-thumb"><img src="' + thumb(it.image, 200, 267) + '" alt=""></div>'
          : '<div class="ed-cart-thumb"></div>';
        var meta = (it.variant_title && it.variant_title !== 'Default Title')
          ? '<div class="ed-cart-meta">' + it.variant_title + '</div>'
          : '';
        return '<li class="ed-cart-item">' + img +
          '<div class="ed-cart-lines">' +
            '<a class="ed-cart-name" href="' + it.url + '">' + it.product_title + '</a>' + meta +
            '<div class="ed-cart-row">' +
              '<span class="ed-cart-qty">' +
                '<button data-mio-qty="' + (it.quantity - 1) + '" data-key="' + it.key + '" aria-label="−">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button data-mio-qty="' + (it.quantity + 1) + '" data-key="' + it.key + '" aria-label="+">+</button>' +
              '</span>' +
              '<span class="ed-cart-price">' + money(it.final_line_price) + '</span>' +
            '</div>' +
            '<button class="ed-cart-remove" data-mio-remove data-key="' + it.key + '">' + t('remove', 'Remover') + '</button>' +
          '</div></li>';
      }).join('') + '</ul>';

      if (total) total.textContent = money(cart.total_price);
    }
  };

  /* --- Arranque ------------------------------------------------------------ */
  function boot() {
    initMosaicoInstafeed();
    initHeaderHeight();
    initShopMenu();
    initDrawer();
    initReveal();
    initToTop();
    initGallery();
    initVariants();
    initDensidade();
    initSplitCarrossel();
    initMosaico();
    Cart.init();
  }


  /* --- Mosaico MIO sobre o feed da Instafeed ------------------------------
     A app desenha a grelha; aqui da-se a cada lugar o tamanho do ritmo e
     metem-se os cartoes de texto nas posicoes pedidas. Cada ritmo e uma lista
     de lugares que fecha em linhas completas (6 colunas no ecra largo, 3 no
     telemovel); os posts que sobram ficam escondidos. Quando a app volta a
     desenhar (redimensionar, editor), o observador repete o trabalho. */
  var RITMOS = {
    a: { 6: 'b n n n n n n w n n n n n n', 2: 'b n n n n' },
    b: { 6: 'b n n n t n n w n n n n n',   2: 'b n n w n n' },
    c: { 6: 'b n n n n b n n n n n n',     2: 'b n n n n b' },
    n: { 6: 'n n n n n n n n n n n n',     2: 'n n n n n n n n' }
  };
  function vestirMosaico(sec) {
    var wrap = sec.querySelector('#insta-feed .instafeed-new-layout-wrapper');
    if (!wrap || wrap.getAttribute('data-mio-vestido') === '1') return;
    var cols = parseInt(getComputedStyle(sec).getPropertyValue('--ig-cols'), 10) === 2 ? 2 : 6;
    var ritmo = RITMOS[sec.getAttribute('data-ritmo')] || RITMOS.b;
    var lugares = ritmo[cols].split(' ');

    // limpar o que ficou de uma vestimenta anterior
    Array.prototype.slice.call(wrap.querySelectorAll('.mio-ig__cartao')).forEach(function (c) { c.parentNode.removeChild(c); });

    // cartoes de texto, por ordem de posicao (nunca alem do ultimo lugar)
    var frases = Array.prototype.slice.call(sec.querySelectorAll('.mio-apps__frase'));
    frases.sort(function (x, y) { return (+x.getAttribute('data-pos')) - (+y.getAttribute('data-pos')); });
    frases.forEach(function (f) {
      var c = f.cloneNode(true);
      c.removeAttribute('hidden'); c.classList.remove('mio-apps__frase'); c.classList.add('mio-ig__cartao');
      var pos = Math.min(lugares.length, Math.max(1, +f.getAttribute('data-pos') || 1));
      wrap.insertBefore(c, wrap.children[pos - 1] || null);
    });

    // cada filho toma o tamanho do lugar; os que nao tem lugar escondem-se
    Array.prototype.forEach.call(wrap.children, function (el, i) {
      el.classList.remove('sz-b', 'sz-w', 'sz-t', 'mio-ig__extra');
      var sz = lugares[i];
      if (!sz) { el.classList.add('mio-ig__extra'); return; }
      if (sz !== 'n') el.classList.add('sz-' + sz);
    });
    // As fotografias vem com um marcador e a app so as troca quando o seu
    // proprio carregador as ve; depois de mudar a grelha, carregam-se aqui.
    Array.prototype.forEach.call(wrap.querySelectorAll('img[data-instafeed-src]'), function (img) {
      var real = img.getAttribute('data-instafeed-src');
      if (real && img.getAttribute('src') !== real) { img.setAttribute('src', real); img.removeAttribute('loading'); }
    });
    wrap.setAttribute('data-mio-vestido', '1');
  }
  function initMosaicoInstafeed() {
    document.querySelectorAll('[data-mio-mosaico]').forEach(function (sec) {
      var alvo = sec.querySelector('#insta-feed');
      if (!alvo) return;
      vestirMosaico(sec);
      if (alvo.getAttribute('data-mio-observado') === '1') return;
      alvo.setAttribute('data-mio-observado', '1');
      new MutationObserver(function () { vestirMosaico(sec); }).observe(alvo, { childList: true, subtree: true });
      // a app so volta a desenhar quando a largura muda; se so mudar o numero
      // de colunas (rodar o telemovel), veste-se outra vez
      var mq = window.matchMedia('(max-width: 760px)');
      if (mq.addEventListener) mq.addEventListener('change', function () { var w = sec.querySelector('#insta-feed .instafeed-new-layout-wrapper'); if (w) w.removeAttribute('data-mio-vestido'); vestirMosaico(sec); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
